import { Button, Modal, Row, Col, Input, Divider, Form, Select, FormInstance } from 'antd';
import { useEffect, useState } from 'react';
import { getDistrict, getProvince, getSubDistrict } from '../../../Services/Prescription.service';
import { CountryType } from '../../../Pages/Prescription/InterfaceType';
import { isNumeric } from '../../../Utils/common';
import NumericInput from '../../../Utils/NumericInput';

export const DeliveryAddressForm = ({
  open,
  onCancel,
  form,
  addressType,
  onSubmit,
}: {
  open: boolean;
  onCancel: () => void;
  form: FormInstance;
  addressType: string;
  onSubmit: (data: any) => void;
}) => {
  const language = 'th';
  const [provinceList, setProvinceList] = useState<CountryType[]>([]);
  const [districtList, setDistrictList] = useState<CountryType[]>([]);
  const [subDistrictList, setSubDistrictList] = useState<CountryType[]>([]);
  const [provinceCode, setProvinceCode] = useState('');
  const [, setDistrictCode] = useState('');
  const [subDistrictCode, setSubDistrictCode] = useState('');
  const { Option } = Select;
  const [latLong, setLatLong] = useState('');

  const handleChangeLatLong = (latLong: string) => {
    setLatLong(latLong);
  };

  useEffect(() => {
    if (open) {
      form.resetFields();
      getProvinceList();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  const getProvinceList = async () => {
    const rsProvince = await getProvince(addressType, language);
    setProvinceList(rsProvince.datas);

    if (provinceCode) {
      const rsDistrict = await getDistrict(addressType, provinceCode, language);
      setDistrictList(rsDistrict.datas);
    }
  };
  const onChangeDistrict = async (districtCode: string, even: string) => {
    const res = await getSubDistrict(addressType, districtCode, language);
    if (res && res.datas) {
      setSubDistrictList(res.datas);
    } else {
      setSubDistrictList([]);
    }
    setDistrictCode(districtCode);

    if (even === 'SELECT') {
      setSubDistrictCode('');
    }
  };

  const onChangeProvince = async (provinceCode: string, event: string) => {
    const res = await getDistrict(addressType, provinceCode, language);
    setDistrictList(res.datas);
    setSubDistrictList([]);

    setProvinceCode(provinceCode);
    if (event === 'SELECT') {
      setDistrictCode('');
      setSubDistrictCode('');
    }
  };

  const filterOption = (input: any, option: any) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;

  // const updateProfile = async () => {
  //   const [latitude, longitude] = form.getFieldValue("latitude_longitude").split(',').map(Number);
  //   const data = {
  //     profile_id: addressData[0].profile_id,
  //     address_type: addressType,
  //     name: form.getFieldValue("name"),
  //     phone_number: form.getFieldValue("phone_number"),
  //     zipcode: form.getFieldValue("zipcode"),
  //     province_code: form.getFieldValue("province_code"),
  //     amphoe_code: form.getFieldValue("amphoe_code"),
  //     district_code: form.getFieldValue("district_code"),
  //     first_address: form.getFieldValue("address"),
  //     longitude:longitude,
  //     latitude: latitude,
  //   };
  //   const updateData = await updateDeliveryAddress(data)
  // };

  return (
    <div>
      <Modal
        open={open}
        onCancel={onCancel}
        title="เพิ่มที่อยู่ใหม่"
        centered
        width={1000}
        footer={[
          <Button onClick={form.submit} type="primary">
            บันทึก
          </Button>,
          <Button onClick={onCancel} key="back" type="default">
            ยกเลิก
          </Button>,
        ]}
      >
        <Divider />
        <Form onFinish={onSubmit} form={form} layout="vertical">
          <Row gutter={24}>
            <Col span={8}>
              <Form.Item label={'ชื่อ-สกุล ผู้รับ'} name={'name'} rules={[{ required: true }]}>
                <Input />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item {...isNumeric} label={'เบอร์โทรศัพท์'} name={'phone_number'} rules={[{ required: true }]}>
                <Input />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label={'ที่อยู่'} name={'address'} rules={[{ required: true }]}>
                <Input />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={8}>
              <Form.Item label={'จังหวัด'} name={'province_code'} rules={[{ required: true }]}>
                <Select
                  showSearch
                  allowClear
                  filterOption={filterOption}
                  placeholder="เลือก จังหวัด"
                  onChange={(e) => onChangeProvince(e, 'SELECT')}
                >
                  {provinceList.map((e, index: number) => (
                    <Option key={index} value={e.province_code}>
                      {e.province_name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label={'เขต/อำเภอ'} name={'amphoe_code'} rules={[{ required: true }]}>
                <Select
                  allowClear
                  showSearch
                  filterOption={filterOption}
                  placeholder="เลือก เขต/อำเภอ"
                  onChange={(e) => onChangeDistrict(e, 'SELECT')}
                >
                  {districtList.map((e, index: number) => (
                    <Option key={index} value={e.district_code}>
                      {e.district_name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label={'แขวง/ตำบล'} name={'district_code'} rules={[{ required: true }]}>
                <Select
                  showSearch
                  allowClear
                  filterOption={filterOption}
                  placeholder="เลือก แขวง/ตำบล"
                  onChange={() => setSubDistrictCode(subDistrictCode)}
                >
                  {subDistrictList.map((e, index: number) => (
                    <Option key={index} value={e.sub_district_code}>
                      {e.sub_district_name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={8}>
              <Form.Item label={'รหัสไปรษณีย์'} name={'zipcode'} rules={[{ required: true }]}>
                <Input />
              </Form.Item>
            </Col>
            <Col span={8}>
              {addressType === '2' ? (
                <Form.Item label={'Latitude, Longitude'} name={'latitude_longitude'} rules={[{ required: true }]}>
                  <NumericInput
                    style={{ width: '100%' }}
                    value={latLong}
                    onChange={handleChangeLatLong}
                    placeholder="ex 13.00000,130.000000"
                  />
                </Form.Item>
              ) : null}
            </Col>
          </Row>
        </Form>
      </Modal>
    </div>
  );
};

export default DeliveryAddressForm;
